<div class="inventory-drug-records-container">
  <div class="page-header-container">
    <div>
      <div class="header-composed">
        <a routerLink="/inventory/ndc" class="text-title-2 back-ref">Inventory</a>
        <div class="text-title-2 header">
          {{mostRecentTransaction?.friendlyName}}
        </div>
      </div>

      <div class="page-subheader flex-wrap">
        <div class="inventory-details">
          <div class="label">NDC:</div>
          <div class="value">
            {{mostRecentTransaction?.packageNdc}}
          </div>
        </div>
        <div class="inventory-details">
          <div class="label">Last Transaction Date:</div>
          <div class="value">
            {{mostRecentTransaction?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
          </div>
        </div>
        <div class="inventory-details">
          <div class="label">User:</div>
          <div class="value">
            {{mostRecentTransaction?.firstName}} <ng-container *ngIf="mostRecentTransaction?.lastName && mostRecentTransaction?.lastName[0]">{{mostRecentTransaction?.lastName[0]}}.</ng-container>
          </div>
        </div>
        <div class="inventory-details" *ngIf="inventoryLocationsEnabled">
          <div class="label">ALL Locations On-Hand:</div>
          <div class="value">
            {{allLocationsOnHand}}
          </div>
        </div>
        <div class="inventory-details" *ngIf="inventoryLocationsEnabled">
          <div class="label">Selected Locations On-Hand:</div>
          <div class="value">
            {{selectedLocationsOnHand}}
          </div>
        </div>
        <div class="inventory-details" *ngIf="mostRecentTransaction?.similarOnHand">
          <div class="label">Similar On-Hand:</div>
          <div class="value">
            {{mostRecentTransaction.similarOnHand}}
          </div>
        </div>
      </div>
      <div class="page-subheader">
      
      </div>
    </div>
    <app-inventory-locations-filter *ngIf="inventoryLocationsEnabled"
     [control]="inventoryLocations">
    </app-inventory-locations-filter>
  </div>

  <table class="table-primary">
    <thead>
    <tr>
      <th (click)="sortByColumn('transactionDate')" class="text-left sort recorded" scope="col">
        DATE/TIME
        <img [class.asc]="tableColumns.transactionDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </th>
      <th (click)="sortByColumn('activityType')" class="text-left sort activity" scope="col">
        Activity
        <img [class.asc]="tableColumns.activityType" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </th>
      <th (click)="sortByColumn('locationName')" *ngIf="inventoryLocationsEnabled"
        class="text-left sort" scope="col">
        Location
        <img [class.asc]="tableColumns.locationName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </th>
      <th (click)="sortByColumn('startingQuantity')" class="text-right sort starting" scope="col">
        Starting
        <img [class.asc]="tableColumns.startingQuantity" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </th>
      <th (click)="sortByColumn('addedQuantity')" class="text-right sort count" scope="col">
        Count
        <img [class.asc]="tableColumns.addedQuantity" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </th>
      <th (click)="sortByColumn('endingQuantity')" class="text-right sort on-hand" scope="col">
        On-hand
        <img [class.asc]="tableColumns.endingQuantity" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </th>
      <th (click)="sortByColumn('infoHeading')" class="text-left sort" scope="col">
        Info
        <img [class.asc]="tableColumns.infoHeading" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </th>
    </tr>
    </thead>
    <tbody >
    <tr class="table-row"
        (click)="openWidget(rowData?.id)"
        *ngFor="let rowData of currentFilteredInventoryTransactions$ | async"
    >
      <th class="text-left recorded" scope="row">
        <div class="heading">
          {{rowData?.transactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
        </div>
        <div class="secondary">
          {{rowData?.firstName}} <ng-container *ngIf="rowData?.lastName && rowData?.lastName[0]">{{rowData?.lastName[0]}}.</ng-container>
        </div>
      </th>
      <td class="text-left activity">
        <app-badge [color]="(rowData | transactionBadge)?.color">
          {{(rowData | transactionBadge)?.label}}
        </app-badge>
      </td>
      <td *ngIf="inventoryLocationsEnabled"
        class="text-left location-data sort" scope="col">
        {{rowData.locationName}}
      </td>
      <td class="text-right starting" scope="col">
        {{rowData.startingQuantity | number}}
      </td>
      <td class="text-right count">
        {{rowData.addedQuantity | number}}
      </td>
      <td class="text-right on-hand">
        {{rowData.endingQuantity | number}}
      </td>
      <th class="text-left info-data" (click)="openAuditOrOrder(rowData)">
        <div class="heading" [auditOrderRedirectLinkClass] [activityType]="rowData.activityType">
          {{rowData?.infoHeading}}
        </div>
        <div class="secondary">
          {{rowData?.infoSecondary}}
        </div>
        <div *ngIf="rowData?.infoSecondary2"
            class="secondary"
        >
          {{rowData.infoSecondary2}}
         </div>
      </th>
    </tr>
    </tbody>
  </table>

</div>
